// Grammes offerts : recopie le bonus de la variante choisie (data-sv-bonus) dans la propriété « + bonus offert » du formulaire.
(() => {
  if (window.svBonusPret) return;
  window.svBonusPret = true;
  // remonte jusqu'au premier ancêtre qui contient le champ « + bonus offert » (fiche, fenêtre d'ajout rapide…)
  const conteneur = (el) => {
    let n = el.parentElement;
    while (n && !n.querySelector('[data-sv-bonus-input]')) n = n.parentElement;
    return n || document;
  };
  const appliquer = (radio) => {
    const zone = conteneur(radio);
    const champ = zone.querySelector('[data-sv-bonus-input]');
    if (!champ) return;
    const g = parseInt(radio.dataset.svBonus || '0', 10);
    champ.value = g > 0 ? `${g}g` : '';
    // Ligne « prix au gramme » de la fiche
    const ligne = zone.querySelector('[data-sv-prix-g]');
    const json = zone.querySelector('[data-sv-prix-g-json]');
    if (ligne && json) {
      try {
        const table = JSON.parse(json.textContent);
        if (table[radio.value]) ligne.innerHTML = table[radio.value];
      } catch (e) {}
    }
  };
  const initialiser = () => {
    document.querySelectorAll('input[data-sv-bonus]:checked').forEach(appliquer);
  };
  document.addEventListener('change', (e) => {
    const r = e.target;
    if (r instanceof HTMLInputElement && r.dataset.svBonus !== undefined && r.checked) appliquer(r);
  });
  // Horizon remplace le sélecteur après chaque changement de variante : on relit la valeur cochée
  let attente = 0;
  new MutationObserver(() => { cancelAnimationFrame(attente); attente = requestAnimationFrame(initialiser); }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiser);
  else initialiser();
})();
